import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
